function updateCart(variantId, quantity) {
  fetch("/cart/change.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest",
    },
    body: JSON.stringify({ id: variantId, quantity: quantity }),
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.status == 422) {
        alert("Error: " + data.message);
      } else {
        alert("Cart updated!");
      }
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}

document.addEventListener("DOMContentLoaded", function () {
  let addToCartForms = document.querySelectorAll(".add-to-cart-form");
  let showQuantityButtons = document.querySelectorAll(".show-quantity");

  addToCartForms.forEach((form) => {
    let hideQuantityButton = form.querySelector(".hide-quantity");

    hideQuantityButton.addEventListener("click", function () {
      form.style.display = "none";
      form.nextElementSibling.style.display = "block";
    });

    let quantityInputs = form.querySelectorAll("input[name='quantity']");
    let variantInputs = form.querySelectorAll("input[name='variant']");

    quantityInputs.forEach((input) => {
      input.addEventListener("change", function () {
        let currentValue = parseInt(input.value);
        let selectedVariantId = parseInt(form.querySelector("input[name='variant']:checked").value);

        if (currentValue === 0) {
          form.style.display = "none";
          form.nextElementSibling.style.display = "block";
        }
        updateCart(selectedVariantId, currentValue);
      });
    });

    let quantityDecreaseButtons = form.querySelectorAll(".quantity-decrease");
    let quantityIncreaseButtons = form.querySelectorAll(".quantity-increase");

    quantityDecreaseButtons.forEach((button) => {
      button.addEventListener("click", function () {
        let input = button.parentNode.querySelector("input[name='quantity']");
        let currentValue = parseInt(input.value);
        let selectedVariantId = parseInt(form.querySelector("input[name='variant']:checked").value);

        if (currentValue > 1) {
          input.value = currentValue - 1;
          updateCart(selectedVariantId, currentValue - 1);
        } else {
          form.style.display = "none";
          form.nextElementSibling.style.display = "block";
        }
      });
    });

    quantityIncreaseButtons.forEach((button) => {
      button.addEventListener("click", function () {
        let input = button.parentNode.querySelector("input[name='quantity']");
        let currentValue = parseInt(input.value);
        let selectedVariantId = parseInt(form.querySelector("input[name='variant']:checked").value);

        input.value = currentValue + 1;
        updateCart(selectedVariantId, currentValue + 1);
      });
    });

    variantInputs.forEach((input) => {
      input.addEventListener("change", function () {
        let selectedVariantId = parseInt(input.value);
        let currentQuantity = parseInt(form.querySelector("input[name='quantity']").value);

        updateCart(selectedVariantId, currentQuantity);
      });
    });
  });

  showQuantityButtons.forEach((button) => {
    button.addEventListener("click", function () {
      button.style.display = "none";
      button.previousElementSibling.style.display = "block";
    });
  });
});
